<script setup>
import Calendar from '@/components/cal/Calendar.vue';
import Datepck from '@/components/cal/DatePck.vue';
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-sheet>
    <div class="cal_area" v-if="rel_flg==false">
        <Datepck v-on:date-select="setCalDate($event)"
             v-on:pick-status="pickStatus($event)"
             v-bind:project="inputPro" ref="dp"
         />
        <Calendar ref="cal" v-bind:project="inputPro" v-bind:selected_cat="selected_cat" v-bind:selected_pro="selected_pro" 
            v-on:editor_open="ediorOpen($event)"
            v-on:rel-dl="dlDoc($event)" />
    </div>
    <form id="edit_area" action="/relcreate" method="post">
        <input type="hidden" name="doc_id"     v-bind:value="added_doc_id" />
        <input type="hidden" name="schedul_id" v-bind:value="added_schedule_id" />
    </form>
</v-sheet>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'イベントカレンダー',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/event.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },

  // データ
  data: function(){
    return {
    // リリース関連関連
    editor_status : {},    
    rel_flg     : false,
    // スケジュールダイアログ
    isModalSchedule : false,
    modalScheduleTitle : '',
    calendar_num : 0,
    input_id    : '',
    input_title : '',
    input_summary : '',
    fromPeriod : '',
    from_obj : null,
    to_obj : null,
    search_obj : null,
    selected_cat : [],
    selected_pro :[],

    title     :"",
    sub_title : "",
    release_date : "",
    summary   : "",
    e_doc     : "",
    signature : "",
    direction : "",

    inputCat: [],
    inputPro: [],
    search_word : '',

    pageing_flg : 0,
    page_index : [],
    page_num : 1,
    maxPage : 1,

    searchCount: [],

    // プロジェクト一覧
    events_list : [],
    // 転載元URLの設定
    input_doc_url : "",
   // プロジェクト追加モーダル表示判定
   isModalSet: false,
   // プロジェクト追加モーダルタイトル
   modalCreateProjectTitle: '',
   // プロジェクト名
       inputModalProjectName: '',
    project  : [],
    added_doc_id : "",
    added_schedule_id : "",
    }
  },
  // 各処理
  methods: {
    dlDoc  : async function(data){
        var params = new URLSearchParams();
        params.append("id",data.doc_id);
        let moment = require('moment');

        await axios.post("https://qlipper.jp/api/release/get_userdoc_list",params)
        .then(response => {
            if(response.data['list'].length==0)
                return;
            this.title = response.data['list'][0].title;
            this.sub_title = response.data['list'][0].sub_title;
            this.summary = response.data['list'][0].summary;
            this.e_doc = response.data['list'][0].doc;
            this.release_date = moment(response.data['list'][0].release_date).format("YYYY年MM月DD日");
            this.direction = response.data['list'][0].direction;
            this.signature = response.data['list'][0].signature;
            if(response.data['list'][0].company_name != '' && response.data['list'][0].company_name != null)
            {
                this.signature = response.data['list'][0].company_name + "\n" + response.data['list'][0].signature;
            }
            this.$nextTick(function (){
                const elem = document.getElementById("dl");
                elem.submit();
            });

        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
    },
    setCalDate : function(data){
        this.$refs.cal.setDate(data.selecteddate);
    },
    ediorOpen  : async function(data){
      this.added_schedule_id = data.release.id;
      // 新規空リリースの追加
      var params = new URLSearchParams();
      params.append("title",data.release.name);
      params.append("schedule_id",this.added_schedule_id);
      await axios.post("https://qlipper.jp/api/release/save_empty_doc",params)
      .then(response => {
          this.added_doc_id  = response.data.id;
        this.$nextTick(function (){
            var elem = document.getElementById('edit_area');
            elem.submit();
        });
       }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
       });
    },
    openSchedule : function (){
        this.$refs.cal.showDial();
    },
    pickStatus   : function(data){
        this.selected_cat = data.cat;
        this.selected_pro = data.pro;
    },
   },
    created: function() {
          // インスタンスが作成された後に実行する処理
        var params = new URLSearchParams();
        axios.post("https://qlipper.jp/api/events/get_project_dsp.php",params)
            .then(response => {
            this.inputPro = response.data;
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
    },
      // インスタンスがマウントされた後に実行する処理
      mounted: function() {
      }
}
</script>
